import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  hasPreviouslyLoggedIn,
  saveHasLoggedIn,
  LOCAL_STORAGE_KEY,
} from "@faire/retailer-visitor-shared/lib/localSession";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { LocalStorage } from "@faire/web--source/common/Storage";
import { trackLoggedOutRetailersPreviouslyVisitedDetails } from "@faire/web-api--source/events/loggedOutRetailers/actionUnknown/previouslyVisitedDetails";
import { trackSigninPreviouslyLoggedIn } from "@faire/web-api--source/events/signin/actionUnknown/previouslyLoggedIn";

export const initializeLocalSessionData = (userToken: string | undefined) => {
  if (isLoggedInRetailer()) {
    saveHasLoggedIn();

    incrementVisitCount("logged-in");
  } else if (userToken) {
    // We don't want to to count brand, admin and other users as logged-out.
  } else {
    trackSigninPreviouslyLoggedIn(`${hasPreviouslyLoggedIn()}`);

    incrementVisitCount("logged-out");

    const data = getPreviouslyVisitedDetailsFromLocalStorage();
    trackLoggedOutRetailersPreviouslyVisitedDetails(
      getGlobalProperty("templatedPath", ""),
      String(data["logged-in"] ?? 0),
      String(data["logged-out"] ?? 0)
    );
  }
};

function incrementVisitCount(kind: "logged-in" | "logged-out"): void {
  const data = getPreviouslyVisitedDetailsFromLocalStorage();
  data[kind] = (data[kind] || 0) + 1;
  setPreviouslyVisitedDetailsToLocalStorage(data);
}

interface PreviouslyVisitedDetails {
  "updated-at"?: number;
  "logged-in"?: number;
  "logged-out"?: number;
}
function getPreviouslyVisitedDetailsFromLocalStorage(): PreviouslyVisitedDetails {
  try {
    return JSON.parse(LocalStorage.get().getItem(LOCAL_STORAGE_KEY) ?? "");
  } catch {
    return {};
  }
}

function setPreviouslyVisitedDetailsToLocalStorage(
  data: PreviouslyVisitedDetails
): void {
  data["updated-at"] = Date.now();
  LocalStorage.get().setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
}
